<template>
  <div>
    <div class="content">
      <v-content>
        <v-layout row wrap align-start>
          <v-flex xs12 md12>
            <h1 class="content-title">SPICE DIGITAL LIMITED</h1>
            <h2 class="content-sub-title">Schedule of Charges</h2>
          </v-flex>

          <v-flex xs12 class="mb-5" v-if="active">
            <table border="1" align="center" class="table table-striped">
              <tr>
                <th colspan="5">Schedule of Charges for walk in customers</th>
              </tr>
              <tr>
                <th colspan="5">for the month of Jun, 2019</th>
              </tr>

              <tr>
                <th>S.No</th>
                <th colspan="2">Service</th>
                <th>Amount slab</th>
                <th>Fee/Charges (₹)</th>
              </tr>

              <tr>
                <td>1</td>
                <td>Spice Money PPI</td>
                <td>percentage of money remitted</td>
                <td>NA</td>
                <td class="right-align">
                  Min Rs 10
                  <br>
                  <br>Max upto 0.70% or Rs 175 whichever is lower (per 25000 Txn)
                </td>
              </tr>

              <tr>
                <td>2</td>
                <td>DMT - BC Model</td>
                <td>percentage of money remitted</td>
                <td>NA</td>
                <td class="right-align">
                  Min Rs 10
                  <br>
                  <br>Max upto 1% or Rs 50 whichever is lower(per Rs 5000 Txn)
                </td>
              </tr>

              <tr>
                <td rowspan="3">3</td>
                <td rowspan="3">AePS</td>
                <td>Balance Enquiry</td>
                <td>NA</td>
                <td class="right-align">₹ 0.00</td>
              </tr>
              <tr>
                <td>Cash Withdrawal</td>
                <td>NA</td>
                <td class="right-align">₹ 0.00</td>
              </tr>
              <tr>
                <td>Cash deposit</td>
                <td>NA</td>
                <td class="right-align">₹ 0.00</td>
              </tr>
              <tr></tr>
              <tr>
                <td rowspan="18">4</td>
                <td rowspan="18">Bharat BillPay</td>
                <td rowspan="3">Electricity</td>
                <td>Upto ₹ 1,000</td>
                <td class="right-align">₹ 5.90</td>
              </tr>
              <tr>
                <td>1000-1999</td>
                <td class="right-align">₹ 17.70</td>
              </tr>
              <tr>
                <td>&gt;= ₹ 2,000</td>
                <td class="right-align">₹ 29.50</td>
              </tr>

              <tr>
                <td rowspan="3">Gas</td>
                <td>Upto ₹ 1,000</td>
                <td class="right-align">₹ 5.90</td>
              </tr>
              <tr>
                <td>1000-1999</td>
                <td class="right-align">₹ 17.70</td>
              </tr>
              <tr>
                <td>&gt;= ₹ 2,000</td>
                <td class="right-align">₹ 29.50</td>
              </tr>

              <tr>
                <td rowspan="3">Water</td>
                <td>Upto ₹ 1,000</td>
                <td class="right-align">₹ 5.90</td>
              </tr>
              <tr>
                <td>1000-1999</td>
                <td class="right-align">₹ 17.70</td>
              </tr>
              <tr>
                <td>&gt;= ₹ 2,000</td>
                <td class="right-align">₹ 29.50</td>
              </tr>

              <tr>
                <td rowspan="3">Landline</td>
                <td>Upto ₹ 1,000</td>
                <td class="right-align">₹ 5.90</td>
              </tr>
              <tr>
                <td>1000-1999</td>
                <td class="right-align">₹ 17.70</td>
              </tr>
              <tr>
                <td>&gt;= ₹ 2,000</td>
                <td class="right-align">₹ 29.50</td>
              </tr>

              <tr>
                <td rowspan="3">Broadband</td>
                <td>Upto ₹ 1,000</td>
                <td class="right-align">₹ 5.90</td>
              </tr>
              <tr>
                <td>1000-1999</td>
                <td class="right-align">₹ 17.70</td>
              </tr>
              <tr>
                <td>&gt;= ₹ 2,000</td>
                <td class="right-align">₹ 29.50</td>
              </tr>

              <tr>
                <td rowspan="3">Mobile Postpaid</td>
                <td>Upto ₹ 1,000</td>
                <td class="right-align">₹ 5.90</td>
              </tr>
              <tr>
                <td>1000-1999</td>
                <td class="right-align">₹ 17.70</td>
              </tr>
              <tr>
                <td>&gt;= ₹ 2,000</td>
                <td class="right-align">₹ 29.50</td>
              </tr>

              <tr>
                <td>5</td>
                <td>DTH</td>
                <td>all operator</td>
                <td>NA</td>
                <td class="right-align">₹ 0.00</td>
              </tr>

              <tr>
                <td rowspan="2">6</td>
                <td rowspan="2">MATM</td>
                <td>Cash withdrawal</td>
                <td>NA</td>
                <td class="right-align">₹ 0.00</td>
              </tr>
              <tr>
                <td>Balance Enquiry</td>
                <td>NA</td>
                <td class="right-align">₹ 0.00</td>
              </tr>
              <tr>
                <td>7</td>
                <td>mPOS</td>
                <td>Cash withdrawal</td>
                <td>NA</td>
                <td class="right-align">₹ 0.00</td>
              </tr>
            </table>
          </v-flex>
        </v-layout>
      </v-content>
    </div>
  </div>
</template>

<style scoped>
h3 {
  font-weight: normal;
  font-size: 18px;
  font-style: italic;
  padding-bottom: 20px;
}
.content-title {
  color: #ed1c24;
  font-size: 24px;
  font-weight: normal;
  margin: 0;
  padding: 0;
  text-transform: uppercase;
}
.content-sub-title {
  font-size: 42px;
  line-height: 42px;
  text-transform: uppercase;
  color: #293896;
  margin-bottom: 30px;
}
.cursorpointer {
  cursor: pointer;
}
.content-image {
  cursor: crosshair;
}
.box-shadow {
  box-shadow: 0 0 30px #e3e3e3;
  background: #fff;
  padding: 40px 48px;
}
.leadership-img {
  position: relative;
  float: left;
}
.leadership-img img {
  position: relative;
  z-index: 3;
  max-width: 100%;
  float: left;
}
.blue-bar {
  width: 100px;
  height: 3px;
  background: #ed1c24;
  margin: 10px 0;
}
.bg-circle {
  position: absolute;
  border-radius: 50%;
  width: 100%;
  height: auto;
  padding-top: 100%;
  border: 2px dashed #a7a8aa;
  filter: alpha(opacity=60);
  filter: alpha(opacity=60);
  opacity: 0.6;
  z-index: 3;
  bottom: 10px;
  right: 10px;
}
.leadership-name {
  color: #2a3997;
  font-size: 30px;

  padding-top: 25px;
}
.leadership-designation {
  color: #242424;
  font-size: 20px;
  font-weight: 300;
}
.grey-circle {
  position: absolute;
  bottom: 0;
  border-radius: 50%;
  width: 100%;
  height: auto;
  padding-top: 100%;
  background-color: #ededed;
}
.learship-container {
  transition: all ease-in-out 0.5s;
}
.learship-container:hover {
  transform: scale(1.05, 1.05);
}
.red-button {
  margin-top: 30px;
  height: 80px;
  line-height: 80px;
  text-decoration: none;
  padding: 0 50px;
  border-radius: 3px;
  color: #fff;
  background: #ec1c25;
  display: inline-block;
  text-transform: uppercase;
  font-size: 30px;
  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.5);
}
ul {
  padding-top: 10px;
}
a {
  text-decoration: none;
}

@media only screen and (max-width: 768px) {
  .content-title {
    font-size: 14px;
  }
  .content-sub-title {
    font-size: 16px;
    line-height: 16px;
  }

  h3 {
    font-size: 14px;
  }
  .leadership-name {
    font-size: 16px;
    padding-top: 25px;
  }
  .leadership-designation {
    font-size: 14px;
    min-height: inherit;
  }
  .red-button {
    margin-top: 20px;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    font-size: 16px;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
}
table td {
  padding: 10px !important;
}
table th {
  padding: 10px !important;
}
.right-align {
  text-align: right;
}
</style>

<script>
import SOC from "./SOC.ts";
export default SOC;
</script>